// tslint:disable: max-line-length
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { AgGridModule } from 'ag-grid-angular';
import {OrderListModule} from 'primeng/orderlist';
import { InputSwitchModule } from 'primeng/inputswitch';
import { TabViewModule } from 'primeng/tabview';

import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './pages/app-bootstrap/app.component';
import { HomePageComponent } from './pages/home-page/home-page.component';

import { DevwareCoreModule,
  DevwareOrmModule,
  DevwareUIModule,
  DevwareAGGridModule,
  DevwareUILayoutModule,
  DevwareUIMetaDataModule,
  DevwareAdminModule,
  DevwareUiWizardModule,
  DwConfigLoaderToken,
  DevwareMediaModule} from '@devwareapps/devware-cap';

import { AppDevwareConfigProvider } from './app-devware-config';
import { DevwareRouteSetupService } from './app-devware-routes';


import { EquipTemplateSectionComponent } from './customizations/equip-request/components/equip-template-section/equip-template-section.component';
import { GoogleMapComponent } from './shared/google-map/components/google-map.component';
import {GoogleMapsModule} from '@angular/google-maps';
import { EquipEmailActionService } from './customizations/equip-request/actions/equip-email-action.service';
import { LicensesSaveActionService } from './customizations/licenses/actions/licenses-save-action.service';
import { FileControlComponent } from './shared/files/file-control/components/file-control.component';
import {FileControlConfigComponent} from './shared/files/file-control/components/file-control-config/file-control-config.component';

import { GoogleMapConfigComponent } from './shared/google-map/components/google-map-config/google-map-config.component';

import { EquipGridReadonlySectionComponent } from './customizations/equip-request/components/equip-grid-readonly-section/equip-grid-readonly-section.component';
import { EventServiceTest } from './customizations/EventServiceHandler/default';
import { PayJobChangeRejectActionService } from './customizations/pay-job-change/actions/pay-job-change-actions-reject.service';
import { PayJobChangeApproveActionService } from './customizations/pay-job-change/actions/pay-job-change-actions-approve.service';
//import { OldTitleComponent } from './customizations/pay-job-change/component/old-title-component/old-title.component';
import { OldManagerComponent } from './customizations/pay-job-change/component/old-manager-component/old-manager.component';
//import { OldTeamComponent } from './customizations/pay-job-change/component/old-team-component/old-team.component';
import {ProjectEndDate} from './customizations/kick-off-document/component/project-end-date/project-end-date.component';
import { AppDevwreBootstrapService } from './app-devware-registrations.service';
import { ProjectStartDate } from './customizations/kick-off-document/component/project-start-date/project-start-date.component';
import { ProjectManager } from './customizations/kick-off-document/component/project-manager/project-manager.component';
import { ProjectName } from './customizations/kick-off-document/component/project-name/project-name.component';
import { CustomerName } from './customizations/kick-off-document/component/customer-name/customer-name.component';
import { FilePondModule, registerPlugin } from 'ngx-filepond';
import FilePondPluginGetFile from 'filepond-plugin-get-file';
import { MorEventHandler } from "./customizations/EventServiceHandler/Mor";
import { ToEmailComponent } from './customizations/memo-of-record/component/to-email-component/to-email-component';
import { MorSaveActionService } from './customizations/memo-of-record/actions/mor-actions-save.service';
//import { EtnEventHandler } from './customizations/EventServiceHandler/Etn';
import { PowerBiComponent } from './shared/power-bi/components/power-bi.component';
import { PowerBiConfigComponent } from './shared/power-bi/components/power-bi-config/power-bi-config.component';
//import { VehicleAccidentEventHandler } from './customizations/EventServiceHandler/VehicleAccident';
import FilePondPluginFileRename from 'filepond-plugin-file-rename';
import FilePondPluginImageOverlay from 'filepond-plugin-image-overlay';
import { ConfigService } from '../environments/environment';
import { CurrentEthosUserContextDefService } from './shared/custom-contexts/dw-current-ethos-user-context.service';
import { QuillModule } from 'ngx-quill';
import { NoteControlComponent } from './shared/notes/note-control/components/note-control.component';
import { NoteControlConfigComponent } from './shared/notes/note-control/components/note-control-config/note-control-config.component';
import { NoteControlNewComponent } from './shared/notes/note-control-new/components/note-control-new.component';
import { WachterNoteEditorComponent, SanitizeHtmlPipe, ToggleToolbar } from './shared/notes/note-control-new/components/wachter-note-editor.component';
import { HorizontalScrollSuppressDirective } from './shared/notes/note-control-new/components/note-control-suppress-scrolling'
import { NoteControlNewConfigComponent } from './shared/notes/note-control-new/components/note-control-new-config/note-control-new-config.component';
//import { TravelEventHandler } from './customizations/EventServiceHandler/Travel';
import { RatingModule } from 'ng-starrating';
import { PowerBiGridComponent } from './shared/power-bi/components/power-bi-grid/power-bi-grid.component';
import { PowerBiGridConfigComponent } from './shared/power-bi/components/power-bi-grid/power-bi-grid-config/power-bi-grid-config.component';

import { EmployeeBanner } from './customizations/ems/components/employee-banner/employee-banner.component';

import { PositionHistoryGridComponent } from './customizations/ems/components/position-history-grid/position-history-grid.component';
import { EmployeeHistoryActionService } from './customizations/ems/actions/employee-history';
import { SearchPipe } from './shared/notes/note-control/components/pipeSearch';
import { LottieModule } from 'ngx-lottie';
import player from 'lottie-web';
// import * as Sentry from "@sentry/angular";
import { APP_INITIALIZER, ErrorHandler } from "@angular/core";
import { Router } from "@angular/router";
import { CovidTestComponent } from './customizations/covid-tracking/components/covid-test/covid-test.component';
import { CovidEmployeeSummaryComponent } from './customizations/covid-tracking/components/covid-employee-summary/covid-employee-summary.component';
import { CovidHomeComponent } from './customizations/covid-tracking/components/covid-home/covid-home.component';

import { ProjectKickoffAddNewJobNumberActionService } from './customizations/project-kickoff/actions/project-kickoff-add-new-jobnumber.service';
import { ProjectKickoffSaveService } from './customizations/project-kickoff/actions/project-kickoff-save.service';
import { PayJobChangeResendApprovalActionService } from './customizations/pay-job-change/actions/pay-job-change-action-resend-workflow.service';
import { PayJobChangeResendApprovedActionService } from './customizations/pay-job-change/actions/pay-job-change-action-resend-approved.service';
import { TermResignResendEmailActionService } from './customizations/term-resign/actions/pay-job-change-action-resend-approved.service';
import { EmployeeMonthlyNumbersContextService } from './customizations/monthly-numbers/context-data/employee-monthly-numbers-context.service';
import { TeamMonthlyNumbersContextService } from './customizations/monthly-numbers/context-data/team-monthly-numbers-context.service';
import { NumbersTeam } from './customizations/monthly-numbers/components/numbers-team/numbers-team.component';
import { TeamYearGrid } from './customizations/monthly-numbers/components/team-year-grid/team-year-grid.component';
import { DwLicenseExpirationValidationRule } from './customizations/licenses/validators/license-expiration-date-validaton-rule.service';
import { EmployeeEvalSurveyComponent } from './customizations/performance-management/components/employee-eval-survey/employee-eval-survey.component';

import { DropdownModule } from 'primeng/dropdown';
import { EmployeeReviewKickoffModalComponent } from './customizations/performance-management/components/employee-review-kickoff-modal/employee-review-kickoff-modal.component';
import { FileControlNewComponent } from './shared/files/file-control-new/componets/file-control-new.component';
import { FileControlNewConfigComponent } from './shared/files/file-control-new/componets/file-control-new-config/file-control-new-config.component';
import { FileExplorerConfigComponent } from './shared/files/file-explorer/components/file-explorer-config/file-explorer-config.component';
import { FileExplorerComponent } from './shared/files/file-explorer/components/file-explorer.component';
import { NewFolderModelComponent } from './shared/files/file-explorer/components/new-folder-model/new-folder-model.component';
import { UploadFileModalComponent } from './shared/files/file-explorer/components/upload-file-modal/upload-file-modal.component';
import { FolderComponent } from './shared/files/file-explorer/components/folder/folder.component';
import { FileExplorerNewComponent } from './shared/files/file-explorer-new/components/file-explorer-new.component';
import { FileExplorerNewConfigComponent } from './shared/files/file-explorer-new/components/file-explorer-new-config/file-explorer-new-config.component';
import { EmployeeReviewKickoffActionService } from './customizations/performance-management/actions/employee-review-kickoff-action.service';
import { EmployeeReviewQuestionSetupComponent } from './customizations/performance-management/components/employee-review-question-setup/employee-review-question-setup.component';
import { EmployeeReviewQuestionSetupCardComponent } from './customizations/performance-management/components/employee-review-question-setup-card/employee-review-question-setup-card.component';
import { EmployeeReviewQuestionSetupListDataSourceService } from './customizations/performance-management/data-sources/employee-review-question-setup-list-datasource.service';
import { EmployeeReviewSummaryComponent } from './customizations/performance-management/components/employee-review-summary/employee-review-summary.component';
import { CurrentEthosUserSubordinatesContextDefService } from './shared/custom-contexts/dw-current-ethos-user-subordinates-context.service';
import { PoiValidatorsComponent } from './customizations/proof-of-insurance/components/poi-validators/poi-validators.component';
import { EmployeeReviewCardComponent } from './customizations/performance-management/components/employee-review-card/employee-review-card.component';
import { EmployeeReviewSkillsGridComponent } from './customizations/performance-management/components/employee-review-skills-grid/employee-review-skills-grid.component';
import { EmployeeReviewChartComponent } from './customizations/performance-management/components/employee-review-chart/employee-review-chart.component';
import { DwMagicImageDirective } from './customizations/performance-management/directives/dw-magic-image.directive';
import { DwImageComponent } from './customizations/performance-management/directives/dw-image/dw-image.component';
import { EmployeeReviewPrintActionService } from './customizations/performance-management/actions/employee-review-print-action.service';
import { ProjectKickoffExternalPrintActionService } from './customizations/project-kickoff/actions/project-kickoff-print-action.service';
import { PermitRequestModalComponent } from './customizations/permits/components/permit-request-modal/permit-request-modal.component';
import { PermitRequestActionService } from './customizations/permits/actions/permit-request-create-permit-action.service';
import { PermitRequestMergedTypeRendererService } from './customizations/permits/columns/permit-request-type-merged-column.service';
import { PermitTypeFilterComponent } from './customizations/permits/filters/permit-type-filter/permit-type-filter.component';
import { PermitRequestUpdateComponent } from './customizations/permits/components/permit-request-update/permit-request-update.component';
import { PermitRequestInspectionActionService } from './customizations/permits/actions/permit-request-inspection-action.service';
import { PermitV2InspectionActionService } from './customizations/permits/actions/permit-v2-inspection-action.service';
import { MedicalRecordEditActionService } from './customizations/accidents/actions/medical-record-action.service';
import { WageExpenseEditActionService } from './customizations/accidents/actions/wage-expense-action.service';
import { PermitV2TakeOwnershipActionService } from './customizations/permits/actions/permit-v2-take-ownership-action.service';
import { PermitV2ChangeRequestActionService } from './customizations/permits/actions/permit-v2-change-request-action.service';
import { EmployeeTypeResetComponent } from './customizations/memo-of-record/component/employee-type-reset/employee-type-reset.component';
import { RejectedNotesModalComponent } from './customizations/pay-job-change/component/rejected-notes-modal/rejected-notes-modal.component';
import { WachterStarRatingControlComponent } from './shared/custom-controls/wachter-star-rating-control/wachter-star-rating-control.component';
import { WachterInputYesNoNullableComponent } from './shared/custom-controls/yes-no-nullable-control/yes-no-nullable-control.component';
import { WachterRadioButtonListComponent } from './shared/custom-controls/radio-button-list-control/radio-button-list-control.component';
import { DynamicNoAccessComponent } from './shared/custom-controls/dynamic-no-access-control/dynamic-no-access-control.component';
import { SurveyValidatorsComponent } from './customizations/surveys/survey-validators.component';
import { CopyEquipRequestComponent } from './customizations/equip-request/components/copy-equip-request/copy-equip-request.component';
import { CopyKickoffButtonComponent } from './customizations/kick-off-document/component/copy-kickoff-button/copy-kickoff-button.component';
import { NotesRepositoryService } from './shared/notes/services/notes-repository-service';
import { PermitTeamDefaultContextService } from './customizations/permits/data-contexts/permit-team-default-context.service';
import { PermitTeamV2DefaultContextService } from './customizations/permits/data-contexts/permit-team-v2-default-context.service';
import { CreateMultipleKickoffsComponent } from './customizations/kick-off-document/component/create-multiple-kickoffs/create-multiple-kickoffs.component';
import { PermitRequestPermitTypeContextService } from './customizations/permits/data-contexts/permit-request-permit-type-context.service';
import { PermitV2PermitTypeContextService } from './customizations/permits/data-contexts/permit-v2-permit-type-context.service';
import { PermitV2JnWjidContextService } from './customizations/permits/data-contexts/permit-v2-jn-wjid-context.service';
import { AvStarRatingNspTechCountContextService } from './customizations/surveys/data-contexts/av-ratings-nsp-tech-count-context.service';
import { PermitV2InspectionCountContextService } from './customizations/permits/data-contexts/permit-v2-inspection-count-context.service';
import { FleetMaintenanceVehicleContextService } from './customizations/fleet/data-contexts/maintenance-vehicle-context.service';
import { FleetAuctionContextService } from './customizations/fleet/data-contexts/auction-responsibility-context.service';
import { QueryString } from './shared/services/querystring.service';
import { FleetVehicleContextService } from './customizations/fleet/data-contexts/vehicle-details-context.service';
import { PayJobChangeSecurityRulesContext } from './customizations/pay-job-change/data-contexts/pay-job-change-security-context.service';
import { PermitRequestPermitTypeColumnService } from './customizations/permits/columns/permit-request-permit-type-column.service';
import { PermitRequestGridDataSourceService } from './customizations/permits/data-sources/permit-request-grid-data-source.service';
import { PermitPermitTypeContextService } from './customizations/permits/data-contexts/permit-permit-type-context.service';
import { PermitPermitTypeColumnService } from './customizations/permits/columns/permit-permit-type-column.service';
import { FleetVehicleIsDOTColumnService } from './customizations/fleet/columns/fleet-isdot-column.service';
import { FleetAuctionActionsColumnComponent } from './customizations/fleet/actions/fleet-auction-actions.component';
import { FleetAuctionCurrentBidColumnService } from './customizations/fleet/columns/fleet-currentbid-column.service';
import { EnhancedUtilsService } from './customizations/utils/services/enhanced-utils.service';
import { PermitGridDataSourceService } from './customizations/permits/data-sources/permit-grid-data-source.service';
import { PermitRequestCreateMultipleActionService } from './customizations/permits/actions/permit-request-create-multiple-action.service';
import { OverheadProjectionsCreateMultipleActionService } from './customizations/numbers/actions/overhead-projections-create-multiple-action.service';
import { WcDatePipe } from './shared/pipes/date-pipe.pipe';
import { TimerUiUtilComponent } from './customizations/timers/components/timer-ui-util/timer-ui-util.component';
import { PermitsV2UiUtilComponent } from './customizations/permits/components/permitsv2-ui-util/permitsv2-ui-util.component';
import { FleetVehicleUiUtilComponent  } from './customizations/fleet/components/vehicle-util.component';
import { EquipRequestUiUtilComponent } from './customizations/equip-request/components/equip-request-ui-util/equip-request-ui-util.component';
import { AccidentUiUtilComponent } from './customizations/accidents/components/accidents-ui-util/accidents-ui-util.component';
import { VehicleAccidentUiUtilComponent } from './customizations/accidents/components/accidents-ui-util/vehicle-accidents-ui-util.component';
import { AvRatingsUiUtilComponent } from './customizations/surveys/components/av-ratings-ui-util.component';
//import { MorNotificationsUiUtilComponent   } from './customizations/memo-of-record/component/notification-config-util.component';
import { TimerCardConfigComponent } from './customizations/timers/components/timer-card-config/timer-card-config.component';
import { TimerAutoRefreshActionComponent } from './customizations/timers/actions/timer-auto-refresh-action/timer-auto-refresh-action.component';
import { FleetAddBidComponent } from './customizations/fleet/actions/fleet-addbid-action.component';
import { TimerAutoRefreshActionConfigComponent } from './customizations/timers/actions/timer-auto-refresh-action/config/timer-auto-refresh-action-config/timer-auto-refresh-action-config.component';
import { EditorModule } from '@progress/kendo-angular-editor';
import { JobTimerCardComponent } from './customizations/timers/components/job-timer-card/job-timer-card.component';
import { TechTimerCardComponent } from './customizations/timers/components/tech-timer-card/tech-timer-card.component';
import { PermitRushGridComponent } from './customizations/permits/components/permit-rush-grid/permit-rush-grid.component';
import { WorkersCompMedicalGridComponent } from './customizations/accidents/components/workers-comp-medical-grid/workers-comp-medical-grid.component';
import { AddNewServiceTypeComponent } from './customizations/fleet/components/add-service-type.component';
import { AddMaintenanceLinkComponent } from './customizations/fleet/components/vehicle-maintenance-link.component';
import { RecentUserProjectionComponent } from './customizations/numbers/components/recent-user-projections.component';
import { AddMaintenanceAddForComponent } from './customizations/fleet/components/vehicle-maintenance-add.component';
import { AddAuctionLinkComponent } from './customizations/fleet/components/vehicle-auction-link.component';
import { AddBidHistoryComponent } from './customizations/fleet/components/add-bid-history.component';
import { WorkersCompWageGridComponent } from './customizations/accidents/components/workers-comp-wage-grid/workers-comp-wage-grid.component';
import { PermitsV2CurrentUserPermitTeamsContext } from './customizations/permits/data-contexts/permits-v2-current-user-permit-teams-context.service';
import { ChangeRequestModalComponent } from './customizations/permits/components/change-request-modal/change-request-modal.component';
import { KickoffBillingDepartmentsColumnComponent } from './customizations/project-kickoff/columns/kickoff-billing-departments-column.component';
import { ProjectKickoffFormDataSourceService } from './customizations/project-kickoff/data-sources/project-kickoff-form-data-source.service';

registerPlugin(FilePondPluginFileRename);
registerPlugin(FilePondPluginGetFile);
registerPlugin(FilePondPluginImageOverlay);


export function playerFactory() {
  return player;
}


@NgModule({
  declarations: [
    AppComponent,
    HomePageComponent,
    EquipTemplateSectionComponent,
    GoogleMapComponent,
    FileControlComponent,
    FileControlConfigComponent,
    FileControlNewComponent,
    FileControlNewConfigComponent,
    NoteControlComponent,
    NoteControlConfigComponent,
    NoteControlNewComponent,
    WachterNoteEditorComponent, SanitizeHtmlPipe, ToggleToolbar,
    HorizontalScrollSuppressDirective,
    NoteControlNewConfigComponent,
    GoogleMapConfigComponent,
    FileExplorerConfigComponent,
    EquipGridReadonlySectionComponent,
    //OldTitleComponent,
    OldManagerComponent,
    //OldTeamComponent,
    PowerBiComponent,
    PowerBiGridComponent,
    PowerBiGridConfigComponent,
    PowerBiConfigComponent,
    ProjectEndDate,
    ProjectStartDate,
    ProjectManager,
    ProjectName,
    CustomerName,
    ToEmailComponent,
    FileExplorerComponent,
    EmployeeBanner,
    PositionHistoryGridComponent,
    SearchPipe,
    NewFolderModelComponent,
    UploadFileModalComponent,
    FolderComponent,
    CovidTestComponent,
    CovidEmployeeSummaryComponent,
    CovidHomeComponent,
    NumbersTeam,
    TeamYearGrid,
    FileExplorerNewComponent,
    FileExplorerNewConfigComponent,
    EmployeeEvalSurveyComponent,
    EmployeeReviewKickoffModalComponent,
    EmployeeReviewQuestionSetupComponent,
    EmployeeReviewQuestionSetupCardComponent,
    EmployeeReviewSummaryComponent,
    EmployeeReviewCardComponent,
    EmployeeReviewSkillsGridComponent,
    EmployeeReviewChartComponent,
    DwMagicImageDirective,
    DwImageComponent,
    PoiValidatorsComponent,
    PermitRequestModalComponent, ChangeRequestModalComponent,
    PermitTypeFilterComponent,
    RejectedNotesModalComponent,
    PermitRequestUpdateComponent,
    EmployeeTypeResetComponent,
    SurveyValidatorsComponent,
    WachterStarRatingControlComponent,
    WachterInputYesNoNullableComponent,
    WachterRadioButtonListComponent,
    DynamicNoAccessComponent, 
    CopyEquipRequestComponent,
    CopyKickoffButtonComponent,
    CreateMultipleKickoffsComponent,
    WcDatePipe,
    TimerUiUtilComponent,
    PermitsV2UiUtilComponent, AccidentUiUtilComponent, VehicleAccidentUiUtilComponent, //MorNotificationsUiUtilComponent,
    AvRatingsUiUtilComponent,
    FleetVehicleUiUtilComponent, EquipRequestUiUtilComponent,
    TimerCardConfigComponent,
    TimerAutoRefreshActionComponent,
    FleetAddBidComponent,
    TimerAutoRefreshActionConfigComponent,
    JobTimerCardComponent,
    TechTimerCardComponent,
    PermitRushGridComponent, 
    WorkersCompMedicalGridComponent,
    AddNewServiceTypeComponent, AddBidHistoryComponent, AddMaintenanceLinkComponent, 
    AddAuctionLinkComponent, AddMaintenanceAddForComponent,
    RecentUserProjectionComponent,
    WorkersCompWageGridComponent,
    KickoffBillingDepartmentsColumnComponent,
  ],
  imports: [
    BrowserModule,

    BrowserAnimationsModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    OrderListModule,
    InputSwitchModule,
    TabViewModule,
    
    HttpClientModule,
    QuillModule.forRoot(),
    AgGridModule.forRoot(),
    BsDropdownModule.forRoot(),
    DropdownModule,
    DevwareCoreModule,
    DevwareOrmModule,
    DevwareUIModule,
    DevwareAGGridModule,
    DevwareUILayoutModule,
    DevwareUIMetaDataModule,
    DevwareUiWizardModule,
    EditorModule,
    DevwareAdminModule,
    DevwareMediaModule,
    AppRoutingModule,
    GoogleMapsModule,
    FilePondModule,
    RatingModule,
    

    [LottieModule.forRoot({ player: playerFactory })],
  ],
  providers: [
    DevwareRouteSetupService,
    EquipEmailActionService,
    TermResignResendEmailActionService,
    PayJobChangeResendApprovalActionService,
    ProjectKickoffAddNewJobNumberActionService, ProjectKickoffSaveService,
    PayJobChangeResendApprovedActionService,
    LicensesSaveActionService,
    EventServiceTest,
    MorEventHandler,
    //EtnEventHandler,
    //VehicleAccidentEventHandler,
    //TravelEventHandler,
    PayJobChangeRejectActionService,
    PayJobChangeApproveActionService,
    MorSaveActionService,
    EmployeeHistoryActionService,
    AppDevwreBootstrapService,
    CurrentEthosUserContextDefService,
    AppDevwareConfigProvider,
    EmployeeMonthlyNumbersContextService,
    TeamMonthlyNumbersContextService,
    ConfigService,
    DwLicenseExpirationValidationRule,
    EmployeeReviewKickoffActionService,
    EmployeeReviewQuestionSetupListDataSourceService,
    CurrentEthosUserSubordinatesContextDefService,
    EmployeeReviewPrintActionService,
    ProjectKickoffExternalPrintActionService,
    PermitRequestActionService,
    PermitRequestMergedTypeRendererService,
    PermitRequestInspectionActionService, PermitV2InspectionActionService, PermitV2TakeOwnershipActionService, PermitV2ChangeRequestActionService,
    MedicalRecordEditActionService, WageExpenseEditActionService,
    NotesRepositoryService,
    PermitTeamDefaultContextService,
    PermitTeamV2DefaultContextService,
    PermitRequestPermitTypeContextService,
    PermitV2PermitTypeContextService, PermitV2JnWjidContextService, AvStarRatingNspTechCountContextService,
    PermitV2InspectionCountContextService,
    FleetMaintenanceVehicleContextService, FleetAuctionContextService, FleetVehicleContextService,
    QueryString,
    PayJobChangeSecurityRulesContext,
    PermitPermitTypeContextService,
    PermitRequestPermitTypeColumnService,
    PermitPermitTypeColumnService,
    FleetVehicleIsDOTColumnService, FleetAuctionCurrentBidColumnService, FleetAuctionActionsColumnComponent,
    EnhancedUtilsService,
    PermitRequestGridDataSourceService,
    PermitGridDataSourceService,
    PermitRequestCreateMultipleActionService,
    OverheadProjectionsCreateMultipleActionService,
    PermitsV2CurrentUserPermitTeamsContext,
    ProjectKickoffFormDataSourceService,
    {
      provide: DwConfigLoaderToken,
      useExisting: ConfigService,
      multi: true,
    },
    // {
    //   provide: ErrorHandler,
    //   useValue: Sentry.createErrorHandler({
    //     showDialog: false,
    //   }),
    // },
    // {
    //   provide: Sentry.TraceService,
    //   deps: [Router],
    // },
    // {
    //   provide: APP_INITIALIZER,
    //   useFactory: () => () => {},
    //   deps: [Sentry.TraceService],
    //   multi: true,
    // },
    {provide: HTTP_INTERCEPTORS, useClass: AppComponent, multi: true}

  ],
  bootstrap: [AppComponent],
  entryComponents: [
    HomePageComponent,
    EquipTemplateSectionComponent,
    FileControlComponent,
    FileControlConfigComponent,
    FileExplorerConfigComponent,
    FileExplorerComponent,
    WachterNoteEditorComponent, SanitizeHtmlPipe,
    EquipGridReadonlySectionComponent,
    GoogleMapComponent,
    GoogleMapConfigComponent,
    NoteControlComponent,
    NoteControlConfigComponent,
    NoteControlNewComponent,
    HorizontalScrollSuppressDirective, 
    NoteControlNewConfigComponent,
    PowerBiComponent,
    PowerBiConfigComponent,
    PowerBiGridComponent,
    PowerBiGridConfigComponent,
    //OldTitleComponent,
    OldManagerComponent,
    //OldTeamComponent, 
    ProjectEndDate,
    ProjectStartDate,
    ProjectManager,
    ProjectName,
    CustomerName,
    ToEmailComponent,
    EmployeeBanner,
    SearchPipe,
    NumbersTeam
  ]
})
export class AppModule { }
